var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"lg"}},[(_vm.region)?_c('div',{staticClass:"box sombra"},[_c('h3',[_vm._v(_vm._s(_vm.region.name))]),(_vm.region)?_c('region-form',{staticClass:"mt-5",attrs:{"region":_vm.region,"editMode":true}}):_vm._e(),_c('list-communes')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }